export enum AuthErrorMessage {
    invalidEmail = "Invalid email",
    invalidInvite = "Invalid invite",
    forbiddenInvite = "Invalid invite. Contact Admin for help",
    inappropriateInvite = "Invitation email doesn't match registration email",
    invalidProvider = "Email is already in use. Try a different provider",
    lackPermissions = "You don't have permissions to view this page. Ask admin for assistance.",
    invalidCredential = "Email or Password is incorrect",
    differentPasswords = "Passwords don't match. Check again",
    emailAlreadyInUse = "Email is already in use",
    weakPassword = "Password must be 6 characters or longer",
    verificationEmailFailed = "Failed to send verification email. Please try again later",
    default = "Something went wrong. Please try again later"
}
